import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import PengajuanKrs from '../pages/akademik/pengajuanKRS/PengajuanKrs';
import PilihJadwal from '../pages/akademik/pilihJadwal/PilihJadwal';
import Dashboard from '../pages/home/Dashboard';
import Presensi from '../pages/akademik/presensi/Presensi';
import SemesterPendek from '../pages/akademik/semesterpendek/SemesterPendek';
import Khs from '../pages/akademik/khs/KHS';
import Krs from '../pages/akademik/krs/KRS';
import JadwalKuliah from '../pages/akademik/jadwal/JadwalKuliah';
import Biodata from '../pages/biodata/Biodata';
import Transkrip from '../pages/akademik/transkrip/Transkrip';
import PrintTranskripSementara from '../pages/akademik/transkrip/PrintTranskripSementara';
import Evaluasi from '../pages/evaluasi/Evaluasi';
import PertanyaanDosen from '../pages/evaluasi/PertanyaanDosen';
import PrintBio from '../pages/biodata/bioAsset/PrintBio';
import Settings from '../pages/settings/Settings';

import Riwayat from '../pages/keuangan/riwayat/Riwayat';
import Tagihan from '../pages/keuangan/tagihan/Tagihan';
import HistoryBatal from '../pages/akademik/historyBatal/HistoryBatal';


class AdminRoutes extends Component {
    render() {
        return (
            <Fragment>
                {/*main route home  */}
                <Route path="/home" component={Dashboard} />

                {/* main route biodata  */}
                <Route path="/biodata" component={Biodata} />
                <Route path="/printBiodata" component={PrintBio} />

                {/*main route pengajuan krs  */}
                <Route path="/krs/pengajuan" exact component={PengajuanKrs} />

                {/*main route pengajuan krs  */}
                <Route path="/jadwal/pilih" exact component={PilihJadwal} />

                {/*main route pengajuan krs  */}
                <Route path="/presensi" component={Presensi} />

                {/*main route khs  */}
                <Route path="/khs" component={Khs} />

                {/*main route krs  */}
                <Route path="/krs" exact component={Krs} />

                {/*main route jadwal  */}
                <Route path="/jadwal" exact component={JadwalKuliah} />

                {/*main route semester pendek */}
                <Route path="/semesterpendek" component={SemesterPendek} />

                {/*main route semester pendek */}
                <Route path="/transkrip" component={Transkrip} />
                <Route path="/printtranskripsementara" component={PrintTranskripSementara} />

                {/*main route evaluasi */}
                <Route path="/evaluasi">
                    <Evaluasi dataMhs={this.props.dataMhs} />
                </Route>
                <Route path="/pertanyaan-dosen" component={PertanyaanDosen} />

                {/*main route setting */}
                <Route path="/settings" component={Settings} />


                {/*main route riwayat  */}
                <Route path="/riwayat" component={Riwayat} />

                {/*main route tagihan  */}
                <Route path="/tagihan" exact component={Tagihan} />

                {/*main route history batal  */}
                <Route path="/history-batalmk" exact component={HistoryBatal} />

            </Fragment>
        );
    }
}

export default AdminRoutes;